module.exports = __webpack_public_path__ + "static/img/history-bg.77a41cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fission/ExperienceGold/history-bg.png
// module id = j7LZ
// module chunks = 216